var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 5.33203H26.667C28.1337 5.33203 29.3337 6.53203 29.3337 7.9987V23.9987C29.3337 25.4654 28.1337 26.6654 26.667 26.6654H5.33366C3.86699 26.6654 2.66699 25.4654 2.66699 23.9987V7.9987C2.66699 6.53203 3.86699 5.33203 5.33366 5.33203Z",
    stroke: "#343373",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 8L16.0003 17.3333L2.66699 8",
    stroke: "#343373",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail9);
export default __webpack_public_path__ + "static/media/mail9.3412104e874be4ea590ab9fc728b5d1d.svg";
export { ForwardRef as ReactComponent };